<script lang="ts">
  import { pluralize } from '$lib/utils';

  import GamePoster from '$components/GamePoster.svelte';
  import { getGameUrl } from '$lib/getters';

  export let game = {};
  let className = '';
  export { className as class };
  export let lighterHover = false;

  $: startingPrice = game.lowestPriceCents === 0 ? 'Free' : `$${game.lowestPriceCents / 100}`;
  $: href = getGameUrl(game);
</script>

<a
  {href}
  class="focus-visible:bg-ondark-low focus-visible:ring-ondark-focused flex h-14 items-center justify-between space-x-3 rounded-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset sm:px-3 {lighterHover
    ? 'sm:hover:bg-ondark-medium'
    : 'sm:hover:bg-ondark-low'} {className}"
  on:keydown
  on:click
>
  <div class="flex min-w-0 items-center space-x-4">
    <GamePoster {game} class="bg-ondark-low size-6 shrink-0" rounded="rounded" link={false} square />
    <span class="highlight text-ondark-primary truncate">
      {@html game._formatted?.title?.en}
    </span>
  </div>
</a>
